import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { findByPortCallId } from '../stowagePlanComparison/itemFindersUtils';
import { TankPlanCondition } from 'src/enums/stowage/tankPlanCondition';
import { getCargoContentsForCondition } from './cargoConditionUtils';
import Decimal from 'decimal.js';
import { roundTo0Decimal } from 'src/utils/numberHelper';

export const getCargoOnBoardByImosPortCallId = (imosPortCallId: number, stowagePlan: StowagePlan, tankPlanCondition: TankPlanCondition) => {
    const portCall = getCargoSnapshotPortCall(imosPortCallId, stowagePlan, tankPlanCondition);
    if (!portCall) {
        return 0;
    }

    const cargoContents = getCargoContentsForCondition(stowagePlan, portCall, null, tankPlanCondition);
    const totalWeight = cargoContents.reduce((acc, cargoContent) => acc.plus(cargoContent.weight), new Decimal(0)) ?? new Decimal(0);
    return roundTo0Decimal(totalWeight.toNumber());
};

export const getCargoSnapshotPortCall = (
    imosPortCallId: number,
    stowagePlan: StowagePlan,
    tankPlanCondition: TankPlanCondition
) => {
    const portCall = findByPortCallId(imosPortCallId, stowagePlan.rotation);
    if (!portCall || tankPlanCondition !== TankPlanCondition.Departure || !portCall.portClusterName) {
        return portCall;
    }

    const portCallIndex = stowagePlan.rotation.findIndex((candidate) => candidate.portCallGuid === portCall.portCallGuid);
    if (portCallIndex === -1) {
        return portCall;
    }

    let lastClusterPortCall = portCall;
    for (let index = portCallIndex + 1; index < stowagePlan.rotation.length; index++) {
        const candidate = stowagePlan.rotation[index];
        if (candidate.portClusterName !== portCall.portClusterName) {
            break;
        }
        lastClusterPortCall = candidate;
    }

    return lastClusterPortCall;
};
